import * as React from 'react';
import * as styles from './styles.css';

import { IconClose12 } from '@cian/ui-kit';
import { IBackToPageProps } from './types';

export function BackToPageMobile(props: IBackToPageProps) {
  return (
    <a href={props.href} className={styles['mobile']} onClick={props.onClick}>
      <IconClose12 />
    </a>
  );
}
